<template>
  <g>
    <g clip-path="url(#clip0_939_1144)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.82882 15.7749C6.16019 15.7749 6.42882 16.0435 6.42882 16.3749C6.42882 17.9371 7.69521 19.2035 9.25739 19.2035H10.2634C10.5948 19.2035 10.8634 19.4721 10.8634 19.8035C10.8634 20.1348 10.5948 20.4035 10.2634 20.4035H9.25739C7.03247 20.4035 5.22882 18.5998 5.22882 16.3749C5.22882 16.0435 5.49745 15.7749 5.82882 15.7749Z"
        fill="#3E7DC0"
      />
      <path
        d="M17.263 10.0459L15.1994 7.14954L19.3266 7.14954L17.263 10.0459Z"
        fill="#3E7DC0"
      />
      <path
        d="M5.82888 13.4979L3.76526 16.3942L7.8925 16.3942L5.82888 13.4979Z"
        fill="#3E7DC0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.6 3.90841C12.6 3.57704 12.8687 3.30841 13.2 3.30841H14.0057C16.136 3.30841 17.8629 5.03531 17.8629 7.16555C17.8629 7.49692 17.5943 7.76555 17.2629 7.76555C16.9315 7.76555 16.6629 7.49692 16.6629 7.16555C16.6629 5.69805 15.4732 4.50841 14.0057 4.50841H13.2C12.8687 4.50841 12.6 4.23978 12.6 3.90841Z"
        fill="#3E7DC0"
      />
      <path
        d="M21.2118 12.1055C20.7055 11.5991 20.0187 11.3146 19.3026 11.3146H14.4317C13.4376 11.3146 12.6317 12.1205 12.6317 13.1146L12.6317 22.2178C12.6316 23.2119 13.4365 24.0171 14.4306 24.0157C16.576 24.0126 20.0454 24.0069 22.1493 24.0034C23.1435 24.0017 23.9444 23.1943 23.9425 22.2L23.9306 15.9376C23.9293 15.2233 23.6449 14.5386 23.1398 14.0335L21.2118 12.1055Z"
        fill="#3E7DC0"
      />
      <path
        d="M8.88018 0.791022C8.37383 0.284657 7.68706 0.000183105 6.97096 0.000183105H1.80005C0.805937 0.000183105 5.01606e-05 0.806065 4.52221e-05 1.80017L0 10.9033C-4.9385e-06 11.8974 0.804818 12.7026 1.79893 12.7012C3.9444 12.6982 7.41391 12.6924 9.51776 12.6889C10.512 12.6873 11.3128 11.8799 11.311 10.8857L11.2989 4.32322C11.2976 3.60887 11.0132 2.92415 10.5081 2.41902L8.88018 0.791022Z"
        fill="white"
      />
      <path
        d="M8.88018 0.791022C8.37383 0.284657 7.68706 0.000183105 6.97096 0.000183105H1.80005C0.805937 0.000183105 5.01606e-05 0.806065 4.52221e-05 1.80017L0 10.9033C-4.9385e-06 11.8974 0.804818 12.7026 1.79893 12.7012C3.9444 12.6982 7.41391 12.6924 9.51776 12.6889C10.512 12.6873 11.3128 11.8799 11.311 10.8857L11.2989 4.32322C11.2976 3.60887 11.0132 2.92415 10.5081 2.41902L8.88018 0.791022Z"
        fill="url(#paint0_linear_939_1144)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.97096 1.20018H1.80005C1.46868 1.20018 1.20005 1.46881 1.20005 1.80018L1.2 10.9033C1.2 11.2353 1.46786 11.5017 1.79722 11.5012C3.94252 11.4982 7.41188 11.4924 9.51576 11.4889C9.84389 11.4884 10.1116 11.2225 10.111 10.8879L10.0989 4.32542C10.0982 3.92856 9.94021 3.54816 9.65959 3.26754L8.03164 1.63954C7.75033 1.35822 7.3688 1.20018 6.97096 1.20018ZM6.97096 0.000183105C7.68706 0.000183105 8.37383 0.284657 8.88018 0.791022L10.5081 2.41902C11.0132 2.92415 11.2976 3.60887 11.2989 4.32322L11.311 10.8857C11.3128 11.8799 10.512 12.6873 9.51776 12.6889C7.41391 12.6924 3.9444 12.6982 1.79893 12.7012C0.804818 12.7026 -4.93848e-06 11.8974 0 10.9033L4.52221e-05 1.80017C5.01606e-05 0.806065 0.805937 0.000183105 1.80005 0.000183105H6.97096Z"
        fill="#3E7DC0"
      />
      <path
        d="M14.7023 21.0099C14.7023 21.1647 14.8247 21.2871 14.9795 21.2871C15.1343 21.2871 15.2567 21.1647 15.2567 21.0099V20.4591H15.6995L16.2395 21.1431C16.3043 21.2259 16.3871 21.2871 16.5131 21.2871C16.6463 21.2871 16.7759 21.1863 16.7759 21.0315C16.7759 20.9451 16.7399 20.8875 16.6859 20.8191L16.3007 20.3511C16.6067 20.2251 16.8047 19.9803 16.8047 19.5843V19.5771C16.8047 19.3395 16.7291 19.1415 16.5887 19.0011C16.4231 18.8355 16.1747 18.7455 15.8543 18.7455H14.9795C14.8247 18.7455 14.7023 18.8679 14.7023 19.0227V21.0099ZM15.2567 19.9695V19.2459H15.8075C16.0775 19.2459 16.2431 19.3683 16.2431 19.6059V19.6131C16.2431 19.8255 16.0883 19.9695 15.8183 19.9695H15.2567Z"
        fill="white"
      />
      <path
        d="M17.2463 21.5895C17.2463 21.7407 17.3687 21.8631 17.5199 21.8631C17.6711 21.8631 17.7935 21.7407 17.7935 21.5895V21.0135C17.9231 21.1683 18.1031 21.3015 18.3947 21.3015C18.8519 21.3015 19.2731 20.9487 19.2731 20.3043V20.2971C19.2731 19.6527 18.8447 19.2999 18.3947 19.2999C18.1103 19.2999 17.9267 19.4331 17.7935 19.6131V19.5879C17.7935 19.4367 17.6711 19.3143 17.5199 19.3143C17.3687 19.3143 17.2463 19.4367 17.2463 19.5879V21.5895ZM18.2543 20.8371C17.9987 20.8371 17.7863 20.6247 17.7863 20.3043V20.2971C17.7863 19.9767 17.9987 19.7643 18.2543 19.7643C18.5099 19.7643 18.7259 19.9767 18.7259 20.2971V20.3043C18.7259 20.6283 18.5099 20.8371 18.2543 20.8371Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.14446 6.60278C3.02092 6.60278 2.92078 6.70293 2.92078 6.82647C2.92078 6.95 3.02092 7.05015 3.14446 7.05015C3.268 7.05015 3.36814 6.95 3.36814 6.82647C3.36814 6.70293 3.268 6.60278 3.14446 6.60278ZM2.42078 6.82647C2.42078 6.42679 2.74478 6.10278 3.14446 6.10278C3.54414 6.10278 3.86814 6.42679 3.86814 6.82647C3.86814 7.22615 3.54414 7.55015 3.14446 7.55015C2.74478 7.55015 2.42078 7.22615 2.42078 6.82647ZM5.72201 6.41973C5.82224 6.51469 5.82652 6.67292 5.73156 6.77316L3.03156 9.62316C2.9366 9.72339 2.77837 9.72767 2.67814 9.63271C2.5779 9.53775 2.57363 9.37952 2.66859 9.27928L5.36858 6.42928C5.46354 6.32905 5.62178 6.32477 5.72201 6.41973ZM5.3552 8.81294C5.23167 8.81294 5.13152 8.91309 5.13152 9.03662C5.13152 9.16016 5.23167 9.26031 5.3552 9.26031C5.47874 9.26031 5.57889 9.16016 5.57889 9.03662C5.57889 8.91309 5.47874 8.81294 5.3552 8.81294ZM4.63152 9.03662C4.63152 8.63694 4.95552 8.31294 5.3552 8.31294C5.75488 8.31294 6.07889 8.63694 6.07889 9.03662C6.07889 9.4363 5.75488 9.76031 5.3552 9.76031C4.95552 9.76031 4.63152 9.4363 4.63152 9.03662Z"
        fill="#3E7DC0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.20004 0.429077C7.53141 0.429077 7.80004 0.697706 7.80004 1.02908V2.91479C7.80004 3.24616 8.06867 3.51479 8.40004 3.51479H10.2858C10.6171 3.51479 10.8858 3.78342 10.8858 4.11479C10.8858 4.44616 10.6171 4.71479 10.2858 4.71479H8.40004C7.40592 4.71479 6.60004 3.9089 6.60004 2.91479V1.02908C6.60004 0.697706 6.86867 0.429077 7.20004 0.429077Z"
        fill="#3E7DC0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.8856 11.7435C20.217 11.7435 20.4856 12.0122 20.4856 12.3435V14.2292C20.4856 14.5606 20.7542 14.8292 21.0856 14.8292H22.9713C23.3027 14.8292 23.5713 15.0979 23.5713 15.4292C23.5713 15.7606 23.3027 16.0292 22.9713 16.0292H21.0856C20.0915 16.0292 19.2856 15.2234 19.2856 14.2292V12.3435C19.2856 12.0122 19.5542 11.7435 19.8856 11.7435Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_939_1144"
        x1="5.65714"
        y1="-0.832809"
        x2="5.65714"
        y2="10.3085"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#11AAE2" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_939_1144">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
